import React, { useEffect, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import Select from "react-select";
import { ASSET_BASIC_DETAIL, ASSET_SAVE_DETAIL} from "../../../apiClient/apiEndpoints";
import apiClient from "../../../apiClient";
import {
  assetsTag3DResourceLists,
  BtnLoading,
  createNewAssetTags,
  debounce,
  verifyImageResolution
} from "../../utils/operation";
import UploadAsset from "./UploadAsset";
import { toastError } from "../../utils/toast";

const inistialState = { upload: false, progress: 100, url: null };
const thumbnailFileSize = 0.1 * 1024 * 1024          // 100 KB


const BasicDetails = () => {
  const [uploaderKey, setUploaderKey] = useState(0);
  const [thumbnail, setThumbnail] = useState(inistialState);
  const params = useParams();
  const { id } = params;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const configData = useSelector((state) => state.configSlice)
  const userData = useSelector((state) => state.userSlice);
  const tagsData = useSelector((state) => state.tagsSlice);
  const [geometryTagList, setGeometryTagList] = useState([]);
  const [assetAttributesTag, setAssetAttributesTag] = useState([]);
  const [polygons, setPolygons] = useState("");
  const [btnText, setBtnText] = useState("Save");
  const [vertices, setVertices] = useState("");
  const [fileError, setFileError] = useState(null);
  const [saveAssets, setSaveAssets] = useState(false);
  const [assetError, setAssetError] = useState(null);
  const [selectedAttributes, setSelectedAttributes] = useState([]);
  const [geometryTag, setGeometryTag] = useState(null);


  const [error, setError] = useState({
    error: false,
    thumbnail: null,
    name: null,
    tags: null,
    geometry: null,
    polygons: null,
    vertices: null,
    assetAttributes: null
  });

  const assetTagsList = async () => {
    let _data = await assetsTag3DResourceLists();
    setGeometryTagList(_data?.geometryTag || []);
    setAssetAttributesTag(_data?.assetAttributesTag || []);
  }

  useEffect(() => {
    assetTagsList();
  }, [tagsData]);


  const getBasicDetails = async () => {
    try {
      let _data = await assetsTag3DResourceLists();
      let data = await apiClient.get(`${configData.config.UNO_URL}${ASSET_BASIC_DETAIL}/${id}`);
      let moduleData = data[0];

      setName(moduleData.name);

      let moduleTags = moduleData?.tags?.map((item) => ({
        value: item.id,
        label: item.name,
        categoryId: item.categoryId,
      }));

      setThumbnail({ uploaded: true, url: moduleData.thumbnail || null });
      setPolygons(moduleData.versions[0].data.polygons || "");
      setVertices(moduleData.versions[0].data.vertices || "");
      setGeometryTag(moduleTags.find(e => _data?.geometryTag.find(f => f.value === e.value)));
      setSelectedAttributes((moduleTags.filter(e => _data?.assetAttributesTag.some(f => f.value === e.value))).map(m => m.value));

    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getBasicDetails();
  }, [id])

  const handleCancel = () => {
    setThumbnail(inistialState);
  };


  const uploadThumbnailImage = async (files) => {
    try {

        setFileError(null);
  
        // if (files.size >= thumbnailFileSize ) {
        //   toastError("File Size is more than 100 KB");
        //   setFileError("File Size is more than 100 KB");
        //   setUploaderKey((prevKey) => prevKey + 1);
        //   return
        //  }

         let imageVerify = await verifyImageResolution(files, 512, 512);
         if(!imageVerify){
          setUploaderKey((prevKey) => prevKey + 1);
           return
         }

        setThumbnail({ ...thumbnail, upload: true })
        const uploadedFile = files;

        const formData = new FormData();
          formData.append('file', uploadedFile);
          var response = await axios.post(`${configData.config.UNO_URL}/api/resource/upload/temp`, formData, {
            headers: {
              Authorization: `Bearer ${userData?.token}`,
              "Content-Type ": "multipart/form-data"
            }
          });

        setThumbnail({ ...thumbnail, upload: false, url: response.data.url })

    } catch (error) {
      console.log(error);
      setFileError("Something went wrong.");
      setUploaderKey((prevKey) => prevKey + 1);
    }

  };

  const handleCheckboxChange = (event) => {
    let { id } = event.target;
    id = parseInt(id);
    setSelectedAttributes((prevSelected) => {
      if (prevSelected.includes(id)) {
        return prevSelected.filter((item) => item !== id);
      } else {
        return [...prevSelected, id];
      }
    });
  };
 

  const checkValidation = () => {
    const errors = {
      name: name.trim().length === 0,
      thumbnail: !thumbnail.url,
      geometryTag: !geometryTag,
      polygons: !polygons || polygons.trim().length === 0,
      vertices: !vertices || vertices.trim().length === 0,
      selectedAttributes: selectedAttributes.length === 0
    };

    const errorStatus = Object.values(errors).some((hasError) => hasError);
  
    if (errorStatus) {
      toastError("Kindly fill all required inputs.");
      setError((prev) => ({ ...prev, error: true }));
      setTimeout(()=>{ setError((prev) => ({ ...prev, error: false })); }, 5000);
    }
  
    return errorStatus;
  };

  const handelSaveDetailsAndAsset = async () => {
      try {
        setError({
          error: false,
          thumbnail: null,
          name: null,
          tags: null,
          geometry: null,
          polygons: null,
          vertices: null,
          assetAttributes: null
        });
      
        if (checkValidation()) return;

        setSaveAssets(true)
        setTimeout(()=>{ setSaveAssets(false) }, 5000);

      } catch (error) {
        console.error(error);
      }finally{
        setLoading(false);
      }

  }

  const handelSaveDetails = async () => {
    try {

      let allTagsList = [];

      selectedAttributes.map((e) => {
        return allTagsList.push(Number(e));
      });

      if (geometryTag?.value) {
        allTagsList.push(Number(geometryTag.value))
      }

      const _bodyData = {
        name: name,
        tags: [...allTagsList],
        thumbnail: thumbnail.url,
        assetFilterId: configData.config.assetFilterId,
        polygons: polygons,
        vertices: vertices
      }

      await apiClient.post(`${configData.config.UNO_URL}${ASSET_SAVE_DETAIL}/${id}`, _bodyData);
      getBasicDetails();
      setBtnText("Saved");

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      setTimeout(()=>{
      setBtnText("Save");
      },2000)
    }
  }

  const handleDebounceSaveDetails = debounce(handelSaveDetailsAndAsset, 500, setLoading);

  return (
    <>
      <div className="mainbox mt-1">
        <div className="row mt-3">

          <div className="col-lg-4 col-md-4">
            <div className="col imgupload">
              <label className="mb-3" >
                File Thumbnail (Max size: 1MB) <span>*</span>
              </label>

              <div className="img-view">
                {thumbnail.url ? (
                  <>
                    <div className='modulepic justify-content-start'  >
                      <div className="thumbnailImageDiv">
                        <img id="thumbnailImage" src={thumbnail.url} alt="" />
                        <span onClick={handleCancel} className="canceldelete">
                          x
                        </span>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className='modulepic justify-content-start'  >
                    <div className="thumbnailImageDiv">
                      <div className='fileuploader'>
                        <FileUploader
                          key={uploaderKey}
                          name="thumbnailInput"
                          types={['png','jpg','jpeg']}
                          label="drag & drop or choose file to upload"
                          handleChange={uploadThumbnailImage}
                        />
                  </div>
                  </div>
                  </div>
                )}

                 <div className="uploadpromt">
                    <p className="recommend">Required Resolution* (512px &times; 512px)</p>
                    <p className="recommend">File format accepted: PNG (Preferably without background)</p>
                    <p className="fileError">{fileError}</p>
                </div>

              </div>
             
            </div>

          </div>

          <div className="col-lg-8 col-md-4">
            <div className='row ps-3'>

              <div className="col-lg-6 col-lg-6">
                <div className="form-group mt-0">
                  <p>Name <span>*</span></p>
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="form-control mt-2"
                    id="exampleFormControlInput1"
                    placeholder="Enter File Name"
                  />
                </div>
              </div>

              <div className='col-lg-6 col-lg-6'>
                <div className="form-group mt-0">
                  <p htmlFor="exampleFormControlInput4">Geometry<span>*</span></p>
                  <Select
                    name="geometryTag"
                    className="basic-multi-select mt-2"
                    classNamePrefix="select"
                    id="exampleFormControlInput4"
                    placeholder="Select"
                    options={geometryTagList}
                    value={geometryTag}
                    onChange={(e) => setGeometryTag(e)}
                    components={{ NoOptionsMessage: (props) => createNewAssetTags({ ...props, customName: "geometryTag" }) }}
                  />
                </div>
              </div>

              <div className='col-lg-4 col-md-4'>
                <div className="form-group mt-3">
                  <p className=' flex-row' htmlFor="exampleFormControlInput5">Polygons <span>*</span></p>
                  <input
                    type="text"
                    value={polygons}
                    onChange={(e) => setPolygons(e.target.value)}
                    className="form-control mt-2"
                    id="exampleFormControlInput5"
                    placeholder="Enter File Name"
                  />

                </div>
                  {/* <p className='error'>{error.polygons}</p> */}
              </div>

              <div className='col-lg-4 col-md-4'>
                <div className="form-group mt-3">
                  <p className=' flex-row' htmlFor="exampleFormControlInput6">Vertices <span>*</span></p>
                  <input
                    type="text"
                    value={vertices}
                    onChange={(e) => setVertices(e.target.value)}
                    className="form-control mt-2"
                    id="exampleFormControlInput6"
                    placeholder="Enter File Name"
                  />

                </div>
                  {/* <p className='error'>{error.vertices}</p> */}
              </div>

              <div className='col-lg-12 col-md-12'>
                <div className="form-group mt-3 pt-0">
                  <p >Choose Asset Attributes:<span>*</span></p>
                  <div className='threed-list'>

                    {assetAttributesTag.map((item, index) => (
                      <div key={item.value} className="form-check listchild quizhead pt-3 ps-2" style={{ cursor: "auto" }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={item.value}
                          value={item.label}
                          checked={selectedAttributes.includes(item.value)}
                          onChange={handleCheckboxChange}
                        />
                        <p className="form-check-label cursor-pointer" htmlFor={item.value}>
                          {item.label}
                        </p>
                      </div>
                    ))}

                  </div>
                </div>
                  {/* <p className='error'>{error.assetAttributes}</p> */}
              </div>

            </div>
          </div>

        </div>

        <div className='row mt-5'>
          
        <UploadAsset saveAssets={saveAssets} handelSaveDetails={handelSaveDetails} setAssetError={setAssetError} />

        <div className="col-lg-6 d-flex align-item-center justify-content-start"> </div> 

        <div className="col-lg-6 d-flex align-items-end  justify-content-end flex-column ">
                <p className="fileError"> {error.error && ` kindly fill all(*) fields. `}</p>
                {assetError && <p className="fileError"> {assetError}</p> }
                <button className="createbtn" onClick={handleDebounceSaveDetails}>
                  {loading ? <BtnLoading /> : btnText}
                </button>
        </div>

        </div>

      </div>
      
    </>
  )
}

export default BasicDetails;